import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import Layout from './Layout'

import styles from './TextEditor.scss'

const sanitize = str => str.replace(/&nbsp;|\u202F|\u00A0/g, ' ')

export default class TextEditor extends Component {
  constructor(props) {
    super(props)

    this.state = {
      readonly: props.initiallyReadonly
    }
  }

  // Avoid the cursor jumping here. The component is essentially uncontrolled.
  shouldComponentUpdate(nextProps, nextState) {
    if (
      sanitize(nextProps.value) !== sanitize(this.contentRef.current.innerHTML) &&
      nextProps.value !== this.props.value
    ) {
      return true
    }

    if (nextState !== this.state) {
      return true
    }

    return false
  }

  onChange = () => this.props.onChange(this.contentRef.current.innerHTML)

  boldenSelection = e => {
    e.preventDefault()
    document.execCommand('bold')

    this.props.onChange(this.contentRef.current.innerHTML)
  }

  toggleReadonly = e => {
    e.preventDefault()

    this.setState(state => ({ readonly: !state.readonly }))
  }

  contentRef = React.createRef()

  render() {
    const { readonly } = this.state
    const { value, togglableReadonly } = this.props

    return (
      <Layout className={styles.textEditorContainer}>
        <Layout className={styles.textEditorButtons} spaceBetween>
          <Layout>
            <button className={styles.textEditorButton} onClick={this.boldenSelection}>
              <FontAwesomeIcon icon={['fas', 'bold']}/>
            </button>
          </Layout>

          <Layout>
            {togglableReadonly && (
              <button
                className={cx(styles.textEditorButton, { [styles.buttonHighlight]: !readonly })}
                onClick={this.toggleReadonly}
              >
                <FontAwesomeIcon icon={['fas', 'pencil-alt']}/>
              </button>
            )}
          </Layout>
        </Layout>

        <div
          className={cx(styles.textEditor, { [styles.readonly]: readonly })}
          contentEditable={!readonly}
          onInput={this.onChange}
          dangerouslySetInnerHTML={{ __html: value }}
          ref={this.contentRef}
        />
      </Layout>
    )
  }
}

TextEditor.defaultProps = {
  initiallyReadonly: false,
  togglableReadonly: false
}

TextEditor.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  initiallyReadonly: PropTypes.bool,
  togglableReadonly: PropTypes.bool
}
